import { uuid } from "uuidv4";
import { ElementTemplate } from "../models/elementTemplateModel";
import { ElementTemplateActionTypes, SET_ELEMENT_TEMPLATE } from "../types/actions";
import { defaultImg, defaultLogo } from "../utils/constants";

const inputElement: ElementTemplate = {
    id: uuid(),
    name:'Input_',
    type: 'input',
    properties: {
        'type': 'text',
        'className': 'form-control',
        'id': uuid(),
        'placeholder': 'placeholder',
        'required': false,
        'disabled': false,
        'valid_feedback': 'valid',
        'invalid_feedback': 'invalid',
        'lblCssStyles':[],
        'labelPosition':'',
        'labelText': '',
        'labelAlign': 'center',
        'isMarginAll': false,
        'value':'',
        'cssStyles':[],
        'tooltip':'',
        'remark1':'',
        'remark2':'',
        'remark3':'',
        'remark4':'',
        'display':true,
        'flex':'',
        'justifyContent':'',
    },
    styles: {
        height: '',
        width: '',
        display: '',
        fontSize: '',
        color:'',
        margin:'',
        marginTop:'',
        marginBottom:'',
        marginRight:'',
        marginLeft:'',
        textAlign:'center'
    },
}

const inputFileElement: ElementTemplate = {
    id: uuid(),
    name:'File_Input_',
    type: 'file',
    properties: {
        'className': 'form-control',
        'id': uuid(),
        'disabled': false,
        'required': false,
        'lblCssStyles':[],
        'labelPosition': '',
        'labelAlign': 'center',
        'labelText':'',
        'isMarginAll': false,
        'value':'',
        'cssStyles':[],
        'tooltip':'',
        'remark1':'',
        'remark2':'',
        'remark3':'',
        'remark4':'',
        'display':true,
        'flex':'',
        'justifyContent':'',
    },
    styles: {
        height: '',
        width: '',
        display: '',
        fontSize: '',
        color:'',
        margin:'',
        marginTop:'',
        marginBottom:'',
        marginRight:'',
        marginLeft:'',
        textAlign:'center'
    },
}


const textAreaElement: ElementTemplate = {
    id: uuid(),
    name:'Textarea_',
    type: 'txtarea',
    properties: {
        'className': 'form-control',
        'id': uuid(),
        'placeholder': 'placeholder',
        'required': false,
        'disabled': false,
        'value':'',
        'valid_feedback': 'valid',
        'invalid_feedback': 'invalid',
        'lblCssStyles':[],
        'labelPosition': '',
        'labelAlign': 'center',
        'labelText':'',
        'isMarginAll': false,
        'display':true,
        'cssStyles':[],
        'tooltip':'',
        'remark1':'',
        'remark2':'',
        'remark3':'',
        'remark4':'',
        'flex':'',
        'justifyContent':'',
    },
    styles: {
        height: '',
        width: '',
        display: '',
        fontSize: '',
        color:'',
        margin:'',
        marginTop:'',
        marginBottom:'',
        marginRight:'',
        marginLeft:'',
        textAlign:'center'
    },
}

const dropdownElement: ElementTemplate = {
    id: uuid(),
    name:'Dropdown_',
    type: 'dropdown',
    properties: {
        'className': 'form-control',
        'id': uuid(),
        'required': false,
        'disabled': false,
        'isDependant': false,
        'parentDropdownId': '',
        'valid_feedback': 'valid',
        'invalid_feedback': 'invalid',
        'lblCssStyles':[],
        'labelPosition': '',
        'labelAlign': 'center',
        'labelText':'',
        'tooltip':'',
        'display':true,
        'selectedOption': '',
        'isMarginAll': false,
        'flex':'',
        'justifyContent':'',
        'options': [{
            'id' : uuid(),
            'value' : 'test',
            'valueText' : 'test',
            'selected':true,
            'disabled':true,
            'filterValue' : '',
        },{
            'id' : uuid(),
            'value' : 'test1',
            'valueText' : 'test1',
            'selected':false,
            'disabled':false,
            'filterValue' : '',
        },{
            'id' : uuid(),
            'value' : 'test2',
            'valueText' : 'test2',
            'selected':false,
            'disabled':false,
            'filterValue' : '',
        },],
        'cssStyles':[],
        'remark1':'',
        'remark2':'',
        'remark3':'',
        'remark4':'',
    },
    styles: {
        height: '',
        width: '',
        display: '',
        fontSize: '',
        color:'',
        margin:'',
        marginTop:'',
        marginBottom:'',
        marginRight:'',
        marginLeft:'',
        textAlign:'center'
    },
}

const btnElement: ElementTemplate = {
    id: uuid(),
    name:'Button_',
    type: 'btn',
    properties: {
        'className': 'btn',
        'btnType':'btn-primary',
        'outlinedBtn':false,
        'sizebtn':'btn-sm',
        'blockBtn':'',
        'id': uuid(),
        'disabled': false,
        'labelPosition':'',
        'isMarginAll': false,
        'cssStyles':[],
        'btnText':'Test',
        'display':true,
        'tooltip':'',
        'remark1':'',
        'remark2':'',
        'remark3':'',
        'remark4':'',
    },
    styles: {
        height: '',
        backgroundColor:'',
        width: '',
        display: '',
        fontSize: '',
        color:'',
        margin:'',
        marginTop:'',
        marginBottom:'',
        marginRight:'',
        marginLeft:'',
        textAlign:'center'
    },
}
const headingElement: ElementTemplate = {
    id: uuid(),
    name:'Heading_',
    type: 'heading',
    properties: {
        'className': 'form-control',
        'id': uuid(),
        'headingType':'h1',
        'text':'please enter text you want',
        'isMarginAll': false,
        'display':true,
        'cssStyles':[],
        'tooltip':'',
        'remark1':'',
        'remark2':'',
        'remark3':'',
        'remark4':'',
    },
    styles: {
        display: '',
        fontSize: '',
        fontFamily:'',
        color:'',
        margin:'',
        marginTop:'',
        marginBottom:'',
        marginRight:'',
        marginLeft:'',
        textAlign:'center'
    },
}
const lblElement: ElementTemplate = {
    id: uuid(),
    name:'Lable_',
    type: 'lbl',
    properties: {
        'className': 'form-control',
        'id': uuid(),
        'text':'Enter text',
        'isMarginAll': false,
        'display': true,
        'coursorType':"",
        'cssStyles':[],
        'tooltip':'',
        'remark1':'',
        'remark2':'',
        'remark3':'',
        'remark4':'',
    },
    styles: {
        height: '',
        width: '',
        display: '',
        fontSize: '',
        fontFamily:'',
        color:'',
        margin:'',
        marginTop:'',
        marginBottom:'',
        marginRight:'',
        marginLeft:'',
        textAlign:'center'
    },
}

const radioBtnElement : ElementTemplate = {
    id: uuid(),
    name:'Radio_button_',
    type: 'rdioBtn',
    properties: {
        'groupName': 'Group-radio-',
        'id': uuid(),
        'labelRadio':'New Radio Btn',
        'required': false,
        'buttonType':'radio',
        'radioSize':'',
        'isMarginAll': false,
        'marginLeft':'0',
        'marginRight':'0',
        'marginTop':'0',
        'marginBottom': '0',
        'showLabel': true,
        'inline':false,
        'disabled': false,
        'display':true,
        'cssStyles':[],
        'lblCssStyles':[],
        'tooltip':'',
        'remark1':'',
        'remark2':'',
        'remark3':'',
        'remark4':'',
        'labalAlign':true,
        'checked':false,

    },
    styles: {
        fontSize: '',
        color:'',
        margin:'',
        marginTop:'',
        marginBottom:'',
        marginRight:'',
        marginLeft:'',
        textAlign:'center'
    },
}
const checkboxElement : ElementTemplate = {
    id: uuid(),
    name:'Checkbox_',
    type: 'chkBox',
    properties: {
        'groupName': 'Group-check-',
        'id': uuid(),
        'labelRadio':'New Checkbox',
        'buttonType':'checkbox',
        'radioSize':'',
        'isMarginAll': false,
        'marginLeft':'0',
        'marginRight':'0',
        'marginTop':'0',
        'marginBottom':'0',
        'showLabel': true,
        'inline':false,
        'disabled': false,
        'display':true,
        'cssStyles': [],
        'lblCssStyles':[],
        'tooltip':'',
        'remark1':'',
        'remark2':'',
        'remark3':'',
        'remark4':'',
        'labalAlign':true,
        'checked':false,
    },
    styles: {
        fontSize: '',
        color:'',
        margin:'',
        marginTop:'',
        marginBottom:'',
        marginRight:'',
        marginLeft:'',
        textAlign:'center'
    },
}
const ImgElement: ElementTemplate = {
    id: uuid(),
    name:'Image_',
    type: 'img',
    properties: {
        'id': uuid(),
        'imageUrl': defaultImg,
        'isMarginAll': false,
        'alt':'sample image',
        'display':true,
        'disabled': false,
        'coursorType':"",
        'cssStyles':[],
        'tooltip':'',
        'remark1':'',
        'remark2':'',
        'remark3':'',
        'remark4':'',
    },
    styles: {
        height: '',
        width: '',
        display: '',
        fontSize: '',
        fontFamily:'',
        color:'',
        margin:'',
        marginTop:'',
        marginBottom:'',
        marginRight:'',
        marginLeft:'',
        textAlign:'center'
    },
}

const tabElement: ElementTemplate = {
    id: uuid(),
    name:'Tab_',
    type: 'tab',
    properties: {
        'className': 'form-control',
        'id': uuid(),
        'labelPosition':'',
        'labelText':'',
        'disabled': false,
        'display':true,
        'isMarginAll': false,
        'cssStyles':[],
        'remark1':'',
        'remark2':'',
        'remark3':'',
        'remark4':'',
        'flex':'',
        'justifyContent':'',
    },
    styles: {
        height: '',
        width: '',
        margin:'',
        marginTop:'',
        marginBottom:'',
        marginRight:'',
        marginLeft:'',
        textAlign:'center'
    },
}

const navigationElement: ElementTemplate = {
    id: uuid(),
    name:'Navbar_',
    type: 'navbar',
    properties: {
        'id': uuid(),
        'expand':'xl',
        'brandLogo':defaultLogo,
        'brandLogoSize': '30',
        'brandLogoAlt':'New-logo-alt',
        'brandName':'New-Brand-Name',
        'colour':'',
        'bg':'primary',
        'varient':'dark',
        'disabled': false,
        'display':true,
        'gapBetweenLogo':'',
        'cssStyles':[],
        'remark1':'',
        'remark2':'',
        'remark3':'',
        'remark4':'',
        'flex':'',
        'justifyContent':'',
        'tabs':[{
            'id':uuid(),
            'name':'New Tab 1',
            'isDropdown':false,
            'alignRight':false,
            'align':'mr-auto',
            'dropdown':[],
            'cssStyles':[],
        },{
            'id':uuid(),
            'name':'New Tab 2',
            'isDropdown':false,
            'align':'mr-auto',
            'dropdown':[],
            'alignRight':false,
            'cssStyles':[],
        },{
            'id':uuid(),
            'name':'New Dropdown 1 ',
            'isDropdown':true,
            'alignRight':false,
            'align':'mr-auto',
            'cssStyles':[],
            'dropdown':[
                {
                    'id':uuid(),
                    'name':'New Dropdown 1',
                    'isDropdown':false,
                    'dropdown':[],
                    'alignRight':false

                },                {
                    'id':uuid(),
                    'name':'New Dropdown 2',
                    'isDropdown':false,
                    'dropdown':[],
                    'alignRight':false

                },                {
                    'id':uuid(),
                    'name':'New Dropdown 3',
                    'isDropdown':true,
                    'alignRight':false,
                    'dropdown':[
                        {
                            'id':uuid(),
                            'name':'New Dropdown Sub Menu 1',
                            'isDropdown':false,
                            'dropdown':[],
                            'alignRight':false

                        },  {
                            'id':uuid(),
                            'name':'New Dropdown 3',
                            'isDropdown':true,
                            'alignRight':false,
                            'dropdown':[
                                {
                                    'id':uuid(),
                                    'name':'New Dropdown Sub Menu 1',
                                    'isDropdown':false,
                                    'alignRight':false,
                                    'dropdown':[]
                                },
                            ]
                        },
                    ]
                },
            ]
        },
    ]
    },
    styles: {
        height: '',
        width: '',
        margin:'',
        marginTop:'',
        marginBottom:'',
        marginRight:'',
        marginLeft:'',
    },
}

const tableElement: ElementTemplate = {
    id: uuid(),
    name:'Table_',
    type: 'table',
    properties: {
        'className': 'form-control',
        'id': uuid(),
        'tooltip':'',
        'isMarginAll': false,
        'headings': [],
        'headingCssStyles': [],
        'rows': [],
        'tbodyCssStyles':[],
        'disabled': false,
        'display':true,
        'cssStyles':[],
        'remark1':'',
        'remark2':'',
        'remark3':'',
        'remark4':'',
        'displayHeader':true,
        'displayAddrow': false,
        'flex':'',
        'justifyContent':'',
    },
    styles: {
        height: '',
        width: '',
        display: '',
        fontSize: '',
        color:'',
        margin:'',
        marginTop:'',
        marginBottom:'',
        marginRight:'',
        marginLeft:'',
        textAlign:'center'
    },
}

const collapsElement: ElementTemplate = {
    id: uuid(),
    name:`Collapse_`,
    type: 'collaps',
    properties: {
        'id': uuid(),
        'disabled': false,
        'display':true,
        'backgroundColor':'',
        'bodyFontColor':'',
        'cssStyles':[],
        'remark1':'',
        'remark2':'',
        'remark3':'',
        'remark4':'',
        'flex':'',
        'justifyContent':'',
    },
    styles: {
        height: '',
        width: '',
        display: '',
        fontFamily:'',
        fontSize: '',
        color:'',
        margin:'',
        marginTop:'',
        marginBottom:'',
        marginRight:'',
        marginLeft:'',
        textAlign:'center'
    },
}

const videoEmbedElement: ElementTemplate = {
    id: uuid(),
    name:'video_embed_',
    type: 'video',
    properties: {
        'id': uuid(),
        'url': "",
        'isMarginAll': false,
        'tooltip':'',
        'disabled': false,
        'display':true,
        'cssStyles':[],
        'remark1':'',
        'remark2':'',
        'remark3':'',
        'remark4':'',
    },
    styles: {
        height: '50%',
        width: '100%',
        display: '',
        margin:'',
        marginTop:'',
        marginBottom:'',
        marginRight:'',
        marginLeft:'',
        textAlign:'center'
    },
}

const mapEmbedElement: ElementTemplate = {
    id: uuid(),
    name:'map_',
    type: 'map',
    properties: {
        'id': uuid(),
        'url': "",
        'isMarginAll': false,
        'tooltip':'',
        'disabled': false,
        'cssStyles':[],
        'display':true,
        'remark1':'',
        'remark2':'',
        'remark3':'',
        'remark4':'',
    },
    styles: {
        height: '30%',
        width: '80%',
        display: '',
        margin:'',
        marginTop:'',
        marginBottom:'',
        marginRight:'',
        marginLeft:'',
        textAlign:'center'
    },
}

const typographyElement: ElementTemplate = {
    id: uuid(),
    name:'Typography_',
    type: 'typography',
    properties: {
        'id': uuid(),
        'text': "<p>Enter Text</p>",
        'isMarginAll': false,
        'tooltip':'',
        'disabled': false,
        'cssStyles':[],
        'display':true,
        'remark1':'',
        'remark2':'',
        'remark3':'',
        'remark4':'',
        'flex':'',
        'justifyContent':'',
    },
    styles: {
        height: '',
        width: '',
        display: '',
        margin:'',
        marginTop:'',
        marginBottom:'',
        marginRight:'',
        marginLeft:'',
    },
}

const caroulesElement: ElementTemplate = {
    id: uuid(),
    name:'carousel_',
    type: 'carousel',
    properties: {
    //     'id': uuid(),
    //     'slides': [
    //         {
    //             'id': uuid(),
    //             'text': "<p>Enter Text for Slide 1</p>",
    //             'imageSrc': 'path/to/slide1-image.jpg',
    //             'isMarginAll': false,
    //             'tooltip': '',
    //             'disabled': false,
    //             'cssStyles': [],
    //         },
    //         {
    //             'id': uuid(),
    //             'text': "<p>Enter Text for Slide 2</p>",
    //             'imageSrc': 'path/to/slide2-image.jpg',
    //             'isMarginAll': false,
    //             'tooltip': '',
    //             'disabled': false,
    //             'cssStyles': [],
    //         },
    //         // Add more slides as needed
    //     ],
    //     'autoplay': true,
    //     'interval': 5000, // Interval between slides in milliseconds
    //     'showArrows': true,
    //     'showIndicators': true,
    //     'wrapAround': true, // Whether the carousel should wrap around

        'id': uuid(),
        // 'text': "<p>Enter Text</p>",
        'isMarginAll': false,
        'tooltip':'',
        'disabled': false,
        'cssStyles':[],
        'display':true,
        'remark1':'',
        'remark2':'',
        'remark3':'',
        'remark4':'',
        'flex':'',
        'justifyContent':'',
    },
    styles: {
        height: '',
        width: '',
        display: '',
        margin:'',
        marginTop:'',
        marginBottom:'',
        marginRight:'',
        marginLeft:'',
    },
}

const elementTemplateReducerDefaultState: ElementTemplate[] = [
    inputElement,
    inputFileElement,
    textAreaElement,
    dropdownElement,
    btnElement,
    lblElement,
    headingElement,
    radioBtnElement,
    checkboxElement,
    ImgElement,
    tabElement,
    navigationElement,
    tableElement,
    collapsElement,
    videoEmbedElement,
    mapEmbedElement,
    typographyElement,
    caroulesElement];

const elementTemplateReducer = (state: ElementTemplate[] = elementTemplateReducerDefaultState, action: ElementTemplateActionTypes): ElementTemplate[] => {
    switch (action.type) {
        case SET_ELEMENT_TEMPLATE:
            return action.elementTemplates;
        default:
            return state;
    }
}

export default elementTemplateReducer